/* eslint-disable promise/catch-or-return */
import $ from 'jquery';
import { isNil } from 'lodash';
import axios from 'axios';
import {
  videoNotAvailableErrorMessageAttr,
  videoNotAvailableClassName,
  videoErrorMessageClassName,
  videoErrorMessageClass,
  videoPlayerIframeClass,
  customResizeEvent,
} from '../_helpers/constants';

export default class VideoPlayerIframe {
  constructor(elm) {
    this.$element = $(elm);
    this.iFrame = null;
    this.iFrameContainer = null;
    this.container = null;
  }

  checkVideoAvailability(restoreIframe = false) {
    this.setElements();

    if (restoreIframe) {
      this.restoreIframe();
    }
    const src = $(this.iFrame).attr('src').replace('.html', '.js');
    axios
      .get(src)
      .then((resp) => {
        this.restoreIframe();
        return resp;
      })
      .catch(() => {
        this.setContainer();
      });
  }

  setElements() {
    if (isNil(this.$element) || this.$element.length === 0) {
      this.$element = $($(videoPlayerIframeClass)[0]);
    }
    this.iFrame = $(this.$element).find('iframe');
    this.iFrameContainer = $(this.iFrame).parent();
    this.container = $(this.iFrameContainer);
  }

  setContainer() {
    this.container.outerWidth(this.container.outerWidth());
    this.container.outerHeight(this.container.outerHeight());
    this.container.addClass(videoNotAvailableClassName);
    this.setMessage(this.container);
    window.addEventListener(customResizeEvent, () => {
      this.resizePlayer();
    });
  }

  setMessage(container) {
    const message = this.$element.data(videoNotAvailableErrorMessageAttr);
    if (!isNil(message) && message !== '') {
      const errorMessageElement = $(this.$element).find(videoErrorMessageClass);
      if (isNil(errorMessageElement) || errorMessageElement.length === 0) {
        container.prepend(`<span class="${videoErrorMessageClassName}">${message}</span>`);
      } else {
        errorMessageElement.show();
      }
      this.iFrame.hide();
    }
  }

  restoreIframe() {
    this.errorMessageElement = $(this.$element).find(videoErrorMessageClass);
    if (!isNil(this.errorMessageElement) && this.errorMessageElement.length > 0) {
      this.errorMessageElement.hide();
    }
    this.iFrame.show();
    this.container.removeClass(videoNotAvailableClassName);
  }

  resizePlayer() {
    this.setElements();
    this.container.outerWidth(this.$element.outerWidth());
  }

  init() {
    this.checkVideoAvailability();
  }
}
